import { useEffect, useState } from 'react';
import API_URL from '../../apiConfig';

function Gestion() {
  const [meditations, setMeditations] = useState([]);
  const [types, setTypes] = useState([]);
  const [editingMeditation, setEditingMeditation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [errorStatus, setErrorStatus] = useState(false);

  const [formData, setFormData] = useState({
    type: '',
    linkVideo: null,
    linkImg: [], // Tableau d'images
    textMedit: '',
    linksFiveImgs: [],
    datePublication: '',
  });

  const formatDateForInput = (mysqlDate) => {
    if (!mysqlDate) return '';
    const date = new Date(mysqlDate);
    if (isNaN(date)) return '';
    const pad = n => (n < 10 ? '0' + n : n);
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const fetchMeditations = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/meditations/allmeditations`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      });
      const data = await res.json();
      if (data.success) setMeditations(data.meditations);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchTypes = async () => {
    try {
      const res = await fetch(`${API_URL}/maj/types`, { credentials: 'include' });
      const data = await res.json();
      if (data.success) setTypes(data.types);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    document.title = "LAMP | Admin - Gestion";
    fetchMeditations();
    fetchTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "linkImg") {
      setFormData(prev => ({ ...prev, linkImg: files ? Array.from(files) : [] }));
    } else if (files) {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setErrorStatus(false);
    
    const url = editingMeditation
      ? `${API_URL}/maj/meditations/update/${editingMeditation.idMedit}`
      : `${API_URL}/maj/meditations/create`;
    const method = editingMeditation ? "PUT" : "POST";

    const payload = new FormData();
    payload.append('type', formData.type);
    payload.append('textMedit', formData.textMedit);
    payload.append('datePublication', formData.datePublication);

    if (formData.linkVideo instanceof File) payload.append('linkVideo', formData.linkVideo);
    
    // Ajout des images du tableau linkImg
    if (formData.linkImg.length > 0) {
      formData.linkImg.forEach(file => {
          if (file instanceof File) payload.append('linkImg', file);
      });
    }

    try {
      const res = await fetch(url, { method, body: payload, credentials: "include" });
      const data = await res.json();
      if (data.success) {
        setMessage(editingMeditation ? "Modifiée ! ✨" : "Enregistrée ! 🚀");
        setFormData({ type: '', linkVideo: null, linkImg: [], textMedit: '', linksFiveImgs: [], datePublication: '' });
        setEditingMeditation(null);
        fetchMeditations();
      } else {
        setMessage("Une erreur est survenue.");
        setErrorStatus(true);
      }
    } catch (err) {
      setMessage("Erreur serveur.");
      setErrorStatus(true);
    }
  };

  const handleDelete = async (idMedit) => {
    if (!window.confirm("🗑️ Supprimer définitivement ?")) return;
    try {
      const res = await fetch(`${API_URL}/maj/meditations/delete/${idMedit}`, { method: "DELETE", credentials: "include" });
      const data = await res.json();
      if (data.success) {
        setMessage("Supprimée !");
        fetchMeditations();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (m) => {
    setEditingMeditation(m);
    setFormData({
      type: m.type,
      linkVideo: null,
      linkImg: [], // On ne remplit pas les fichiers existants par sécurité, l'utilisateur uploade les nouveaux
      textMedit: m.textMedit || '',
      linksFiveImgs: [],
      datePublication: formatDateForInput(m.datePublication),
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="container-fluid py-4 animate__animated animate__fadeIn">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold outfit text-dark">⛓️ Gestion des Méditations</h2>
      </div>

      <div className="row g-4">
        {/* Formulaire de création / édition */}
        <div className="col-lg-5">
          <div className="card-custom border-0 shadow-sm p-4 rounded-4 bg-white sticky-top" style={{ top: '20px' }}>
            <h5 className="fw-bold mb-4">
              <i className={`bi ${editingMeditation ? 'bi-pencil-square text-primary' : 'bi-plus-circle-fill text-success'} me-2`}></i>
              {editingMeditation ? "Modifier" : "Ajouter Nouveau"}
            </h5>

            <form onSubmit={handleSubmit} className="row g-3">
              <div className="col-12 mb-2">
                <label className="small fw-bold text-muted text-uppercase mb-2">Type</label>
                <select name="type" className="form-select border-0 bg-light p-3 rounded-3 shadow-none fw-bold" value={formData.type} onChange={handleChange} required>
                  <option value="">Sélectionner...</option>
                  {types.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>

              <div className="col-12 mb-2">
                <label className="small fw-bold text-muted text-uppercase mb-2">Contenu</label>
                <textarea name="textMedit" className="form-control border-0 bg-light p-3 rounded-3 shadow-none" rows="4" value={formData.textMedit} onChange={handleChange} placeholder="..." required></textarea>
              </div>

              <div className="col-12 mb-2">
                    <label className="small fw-bold text-muted text-uppercase mb-2 d-flex justify-content-between">
                        <span>📷 Images (max 6)</span>
                        {formData.linkImg.length > 0 && <span className="badge bg-primary px-2">{formData.linkImg.length} image(s)</span>}
                    </label>
                    <div className="border border-2 border-dashed rounded-4 p-4 text-center bg-light position-relative mb-3">
                        <i className="bi bi-images fs-2 text-primary opacity-50 mb-2 d-block"></i>
                        <p className="small text-muted mb-0">Cliquez pour sélectionner 1 à 6 images</p>
                        <p className="extra-small text-muted mb-0">(Maintenir CTRL pour en choisir plusieurs)</p>
                        <input 
                            type="file" 
                            name="linkImg" 
                            className="position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer" 
                            accept="image/*" 
                            multiple
                            onChange={handleChange} 
                        />
                    </div>
                    {formData.linkImg.length > 0 && (
                        <div className="mb-3 d-flex flex-wrap gap-2">
                            {formData.linkImg.map((file, i) => (
                                <div key={i} className="d-flex flex-column align-items-center gap-1" style={{width: '60px'}}>
                                    <img src={URL.createObjectURL(file)} alt="preview" className="rounded-2 border" style={{width:'60px', height:'50px', objectFit:'cover'}} />
                                    <span className="extra-small text-muted text-truncate w-100 text-center">{i+1}</span>
                                </div>
                            ))}
                        </div>
                    )}

                    <label className="small fw-bold text-muted text-uppercase mb-2">🎬 Vidéo (Format MP4)</label>
                    <div className="border border-2 border-dashed rounded-4 p-3 text-center bg-light position-relative">
                        <i className="bi bi-play-btn fs-3 text-danger opacity-50 mb-1 d-block"></i>
                        <input 
                            type="file" 
                            name="linkVideo" 
                            className="position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer" 
                            accept="video/mp4" 
                            onChange={handleChange} 
                        />
                        <p className="small text-muted mb-0">Importer votre fichier vidéo MP4</p>
                    </div>
              </div>

              <div className="col-12 mb-4">
                <label className="small fw-bold text-muted text-uppercase mb-2">Planification</label>
                <input type="datetime-local" name="datePublication" className="form-control border-0 bg-light p-3 rounded-3 shadow-none fw-bold" value={formData.datePublication} onChange={handleChange} required />
              </div>

              <div className="col-12 d-flex gap-2">
                <button type="submit" className={`btn ${editingMeditation ? 'btn-primary' : 'btn-success'} w-100 py-3 rounded-3 fw-bold`}>
                   {editingMeditation ? "MODIFIER" : "CRÉER"}
                </button>
                {editingMeditation && (
                  <button type="button" className="btn btn-light py-3 rounded-3 border" onClick={() => { setEditingMeditation(null); setFormData({ type: '', linkVideo: null, linkImg: [], textMedit: '', linksFiveImgs: [], datePublication: '' }); }}>
                    X
                  </button>
                )}
              </div>
            </form>

            {message && (
              <div className={`alert ${errorStatus ? 'alert-danger' : 'alert-success'} mt-4 py-2 small rounded-3 border-0`}>
                <i className="bi bi-info-circle me-1"></i> {message}
              </div>
            )}
          </div>
        </div>

        {/* Liste des items existants */}
        <div className="col-lg-7">
          <div className="card-custom border-0 shadow-sm bg-white rounded-4 overflow-hidden">
            <div className="table-responsive">
              <table className="table align-middle table-hover mb-0">
                <thead className="bg-light bg-opacity-50">
                  <tr className="small text-muted text-uppercase">
                    <th className="px-4 py-3">Type</th>
                    <th className="px-4 py-3">Message</th>
                    <th className="px-4 py-3 text-end">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="3" className="text-center py-4"><div className="spinner-border spinner-border-sm text-primary"></div></td></tr>
                  ) : meditations.map((m) => (
                    <tr key={m.idMedit} className="border-bottom border-light">
                      <td className="px-4 py-3">
                        <span className="badge bg-primary bg-opacity-10 text-primary fw-bold px-2 py-1">{m.type}</span>
                      </td>
                      <td className="px-4 py-3">
                        <p className="mb-0 small text-dark fw-medium text-truncate" style={{ maxWidth: '200px' }}>{m.textMedit}</p>
                        <span className="text-muted extra-small">{new Date(m.datePublication).toLocaleDateString()}</span>
                      </td>
                      <td className="px-4 py-3 text-end">
                        <button className="btn btn-sm btn-outline-primary border-0 rounded-circle me-1" onClick={() => handleEdit(m)}><i className="bi bi-pencil-fill"></i></button>
                        <button className="btn btn-sm btn-outline-danger border-0 rounded-circle" onClick={() => handleDelete(m.idMedit)}><i className="bi bi-trash-fill"></i></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .extra-small { font-size: 0.7rem; }
        .cursor-pointer { cursor: pointer; }
      `}</style>
    </div>
  );
}

export default Gestion;
